<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '500px' }"
    header="Paquete Productos Detalle"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <label for="nombre"
            ><strong>NOMBRE DE PAQUETE: </strong>
            <span class="p-invalid">*</span></label
          >
          <InputText
            id="nombre"
            v-model.trim="data_paqueteproducto.nombre"
            required="true"
            autofocus
            @keyup.enter="savePaquete"
          />
          <small class="p-invalid" v-if="errors.nombre">{{
            errors.nombre[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-6">
          <ZapiGrupoDropdown
            v-model="grupoSelect"
          />
          <small class="p-invalid" v-if="errors.grupo_id">{{
            errors.grupo_id[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-6">
          <ZapiSubGrupoDropdown
            v-model="subgrupoSelect"
          />
          <small class="p-invalid" v-if="errors.subgrupo_id">{{
            errors.subgrupo_id[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-12" v-if="data_paqueteproducto.id">
          <label for="estado"
            ><strong>ESTADO: </strong><span class="p-invalid">*</span></label
          >
          <Dropdown
            id="estado"
            v-model="data_paqueteproducto.estado"
            :disabled="!data_paqueteproducto.id"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="flex justify-content-between align-items-center w-full">
        <div>
          <label class="text-sm m-0"
            ><strong>CAMPOS REQUERIDOS: </strong>
            <span class="p-invalid">*</span></label
          >
        </div>
        <div>
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            class="p-button-secondary p-button-lg"
            @click="ocultarDialog"
            :disabled="!enviado ? false : true"
          />
          <Button
            :label="data_paqueteproducto.id ? 'ACTUALIZAR' : 'GUARDAR'"
            icon="pi pi-save"
            class="p-button-primary p-button-lg"
            @click="savePaquete"
            :disabled="!enviado ? false : true"
            :loading="enviado"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import PaqueteProductoService from "@/service/PaqueteProductoService";
import ZapiGrupoDropdown from "@/components/shared/ZapiGrupoDropdown.vue";
import ZapiSubGrupoDropdown from "@/components/shared/ZapiSubGrupoDropdown.vue";

export default {
  components: { ZapiGrupoDropdown, ZapiSubGrupoDropdown },
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    paqueteproducto: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  PaqueteProductoService: null,
  data() {
    return {
      mostrarModal: this.show,
      data_paqueteproducto: this.paqueteproducto,
      enviado: false,
      estados: [
        { label: "Inactivo", value: 0 },
        { label: "Activo", value: 1 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
      grupoSelect: null,
      subgrupoSelect: null,
    };
  },
  created() {
    this.PaqueteProductoService = new PaqueteProductoService();
  },
  methods: {
    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
    },
    savePaquete() {
      this.errors = {};
      this.enviado = true;
      //editar paqueteproducto
      if (this.paqueteproducto.id) {
        let paqueteproducto_enviar = {
          ...this.data_paqueteproducto,
          estado: this.data_paqueteproducto.estado.value,
          grupo_id: this.grupoSelect ? (this.grupoSelect.id !== undefined ? this.grupoSelect.id : this.grupoSelect) : null,
          subgrupo_id: this.subgrupoSelect ? (this.subgrupoSelect.id !== undefined ? this.subgrupoSelect.id : this.subgrupoSelect) : null,
        };
        this.PaqueteProductoService.updatePaqueteProducto(
          paqueteproducto_enviar
        ).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
          } else {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: data.mensaje,
              life: 3000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
          }
          this.enviado = false;
        });
      } else {
        //CREANDO UN NUEVO PROVEEDOR
        let tmp = this.data_paqueteproducto;
        this.data_paqueteproducto = {
          ...this.data_paqueteproducto,
          estado: this.data_paqueteproducto.estado.value,
          grupo_id: this.grupoSelect ? (this.grupoSelect.id !== undefined ? this.grupoSelect.id : this.grupoSelect) : null,
          subgrupo_id: this.subgrupoSelect ? (this.subgrupoSelect.id !== undefined ? this.subgrupoSelect.id : this.subgrupoSelect) : null,
        };
        this.PaqueteProductoService.sendPaqueteProductoNew(
          this.data_paqueteproducto
        ).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
            this.data_paqueteproducto = tmp;
          } else {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: data.mensaje,
              life: 10000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
          }
          this.enviado = false;
        });
      }
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    paqueteproducto(val) {
      this.data_paqueteproducto = val;
      if (val && val.grupo_id) {
        this.grupoSelect = { id: val.grupo_id };
      } else {
        this.grupoSelect = null;
      }
      if (val && val.subgrupo_id) {
        this.subgrupoSelect = { id: val.subgrupo_id };
      } else {
        this.subgrupoSelect = null;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
